import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import isFunction from "lodash/isFunction";
//
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
// component, hooks
import TemplateHome from "../components/TemplateHome";
import useDataLocale from "../../common/hooks/useDataLocale";
// store
import { setTermsOfServiceDesc } from "../../reduxStore/settingSlice";
import {
  // eslint-disable-next-line import/named
  setErrorMessage,
  // eslint-disable-next-line import/named
  setSuccessMessage,
} from "../../reduxStore/commonSlice";
// config,utils
import { convert2HtmlEntities } from "../../common/utils/htmlEntities";
import ApiUrls from "../../api/project/ApiUrls";
import { isEmpty } from "../../common/utils";

// style

const safeList = (list) => list.filter((o) => !isEmpty(o));

const fetchTermsOfService = async (params, onSuccess, onError) => {
  try {
    const url = ApiUrls.getSettingTermsOfService();

    const res = await axios.get(url);

    // 有時 res.data.data 可能為 [{}]
    if (Array.isArray(res?.data?.data)) {
      if (isFunction(onSuccess)) onSuccess(safeList(res?.data?.data));
    } else if (isFunction(onSuccess)) onSuccess([]);
  } catch (err) {
    if (isFunction(onError)) onError(err);
  }
};

const ServicePage = () => {
  // props
  // route,intl
  // store
  const dispatch = useDispatch();
  const settingState = useSelector((_state) => _state.setting);
  const { termsOfServiceDesc } = settingState;
  // local state
  const [descLocale, setDescLocale] = useState("");
  // hooks
  const { dataLocale } = useDataLocale(
    termsOfServiceDesc,
    ApiUrls.getLocale(),
    "lang"
  );

  useEffect(() => {
    const onSuccess = (data) => {
      dispatch(setTermsOfServiceDesc(data));
    };
    const onError = (error) => {
      dispatch(
        setErrorMessage({
          open: true,
          content: error.message,
        })
      );
    };
    if (!termsOfServiceDesc) {
      fetchTermsOfService({}, onSuccess, onError);
    }
  }, [termsOfServiceDesc]);

  useEffect(() => {
    setDescLocale(dataLocale?.[0]?.termsOfService || "");
  }, [dataLocale]);

  return (
    <TemplateHome>
      <Container>
        <Box pt={4} pb={6}>
          {convert2HtmlEntities(descLocale)}
        </Box>
      </Container>
    </TemplateHome>
  );
};

ServicePage.propTypes = {};

ServicePage.defaultProps = {};

export default ServicePage;
